import { render } from "./PaginationArrows.vue?vue&type=template&id=6ea2bcbc&scoped=true"
import script from "./PaginationArrows.vue?vue&type=script&lang=js"
export * from "./PaginationArrows.vue?vue&type=script&lang=js"

import "./PaginationArrows.vue?vue&type=style&index=0&id=6ea2bcbc&scoped=true&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea2bcbc"]])

export default __exports__